import { Button, Divider, Dropdown, Form, Input, Menu, message, Spin, Typography } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { MailOutlined, MoreOutlined } from "@ant-design/icons";
import AccountLoginForm from "../components/components/account/AccountLoginForm";
import { apiCall } from "../components/utilities/Api";
import { STEPS } from "./NewPurchaseLayout";
import { useSession } from "../util/Session";

export default function PurchaseEmailChecker(props) {
    const {
        form,
        status,
        callback = () => { },
    } = props;

    const [params, setParams] = useState({
        exists: false,
        email: false,
        text: false,
    })




    const email = Form.useWatch("email", form);
    const emailRef = useRef(null);
    const [checkedEmail, setCheckedEmail] = useState("");
    const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || "");
    const [loading, setLoading] = useState(false);
    const [session, setSession] = useSession();


    // const checkEmail = (_email) => {

     
    //     const [params, setParams] = useState({
    //         exists: false,
    //         email: false,
    //         text: false,
    //     })

    //     setLoading(true);
    //     setCheckedEmail(email);
    //     apiCall("account/getContactMethods", { email: email }, (_s, _r) => {
    //         setLoading(false);
    //         if (_s) {
    //             if (_r?.exists) {
    //                 setParams(_r)
    //             } else {
    //                 callback(email, true);
    //             }
    //         } else {
    //             message.error(_r.error)
    //         }
    //     })
    // };

    const closeLogin = () => {
        setParams({ ...params, "exists": false })
    };

    useEffect(() => {

        if (status?.step !== STEPS.EMAIL) return;

        setParams({
            exists: false,
            email: false,
            text: false,
        });

        setCheckedEmail("");
        setLoading(false);

        setTimeout(() => {
            if (emailRef?.current) {
                emailRef.current.focus();
                emailRef.current.select();
            }

        }, 0);

    }, [status?.step]);

    if (status?.step !== STEPS.EMAIL) {
        return (<>
            {/* <Divider orientation="left" orientationMargin={0} ><big><strong>Email Address</strong></big></Divider> */}
            <div className="checkout-row">
                <div className="checkout-info">
                    <div className="checkout-icon">
                        <MailOutlined />
                    </div>
                    <div style={{ minWidth: 0 }}>
                        <Typography.Text type="secondary" style={{ display: "block", fontSize: 12 }} > Contact email </Typography.Text>
                        <Typography.Text strong ellipsis style={{ display: "block", maxWidth: 400 }} > {status?.email_address || ""} </Typography.Text>
                    </div>
                </div>
                {!session.logged_in &&
                    <Button type="text" onClick={() => props.changeEmail()} ><small>change</small></Button>
                }
            </div>
        </>)
    }



    return (
        <>

            <Divider orientation="left" orientationMargin={0} ><big><strong>Email Address</strong></big></Divider>

            <div
                className="float-flex"
                style={{
                    alignItems: "center",
                    justifyContent: "stretch",
                    gap: "10px",
                }}
            >


                {/* <Modal
                    footer={null}
                    open={params?.exists || false}
                    onCancel={closeLogin}
                    destroyOnClose
                >
                    {params?.exists && (<>





                        <AccountLoginForm
                            header={<>
                                <strong>Account exists</strong>
                                <Divider style={{ "margin": "15px 0px" }} dashed />
                                <p>An account exists with this email address. You can log in to continue, or <a onClick={() => {
                                    closeLogin();
                                    callback(email);
                                }}>proceed without logging in.</a></p>
                            </>}
                            footer={<>
                                <Divider style={{ "margin": "15px 0px" }}>OR</Divider>
                                <Button onClick={() => {
                                    closeLogin();
                                    callback(email);
                                }} block>Proceed without logging in</Button>
                            </>}
                            recover_email={params?.email}
                            recover_text={params?.text}
                            show_forgot={false}
                            email={email}
                            show_create={false}
                            callback={() => {
                                closeLogin();
                                callback(email);
                            }}
                        />
                    </>
                    )}
                </Modal> */}

                {(!params?.exists &&
                    <Form.Item
                        name="email"
                        style={{ flexGrow: 1 }}
                        rules={[
                            {
                                required: true,
                                message: "Please enter an email address",
                            },
                            {
                                type: "email",
                                message: "Please enter a valid email address",
                            },
                        ]}
                    >
                        <Input.Search
                            style={{ width: "100%" }}
                            type="email"
                            ref={emailRef}
                            enterButton={
                                <Button type="primary" disabled={!validEmail}>
                                    Go
                                </Button>
                            }
                            onSearch={(e) => {
                                if (!validEmail) return;
                                setParams({
                                    exists: true,
                                    email: e,
                                    text: false
                                })
                            }}
                            size="large"
                            prefix={<MailOutlined />}
                            placeholder="name@example.com"
                            autoComplete="email"
                            allowClear
                        />
                    </Form.Item>
                )}
                <Spin spinning={loading} style={{ "width": "100%" }}>

                    {(params?.exists &&

                        <>
                            <AccountLoginForm
                                focus_password
                                header={<>
                                    {/* <strong>Account exists</strong>
                                <Divider style={{ "margin": "15px 0px" }} dashed /> */}
                                    <p>An account exists with this email address. You can log in to continue, or <a onClick={() => {

                                        callback(checkedEmail);
                                    }}>continue as guest.</a></p>
                                </>}
                                footer={<>
                                    <Divider style={{ "margin": "15px 0px" }}>OR</Divider>
                                    <Button type="primary" onClick={() => {
                                        callback(checkedEmail);
                                    }} block>Continue as guest</Button>
                                </>}
                                login_primary={false}
                                init_view={"code"}
                                autofire_verification
                                back_label="Back"
                                back={() => {
                                     setParams({...params, exists : false})
                                }}
                                recover_email={params?.email}
                                recover_text={params?.text}
                                show_forgot={false}
                                email={checkedEmail}
                                show_create={false}
                                callback={(_r) => {

                                    const _new_user = (_r === "new_user") ? true : false;
                                    callback(params?.email, _new_user);
                                }}
                            />
                        </>

                    )}



                </Spin>


            </div>
        </>
    );
}